module.exports = __webpack_public_path__ + "static/media/009_Risco.a4e2f42c.mp4";